import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';

import { ProfileService } from '../services/profile.service';
import { VoxPopService } from '../services/voxpop.service';
import { Programme } from '../types/programme';
import { Topic } from '../types/topic';

@Component({
  selector: 'topics',
  templateUrl: './topics.component.html',
  styleUrls: ['../shared/entity-list.css', './topics.component.css'],
  providers: [VoxPopService],
  standalone: false
})


export class TopicsComponent implements OnInit {
  CanReview = ProfileService.CanReview;
  CanAdminister = ProfileService.CanAdminister;
  adding = false;
  topics: Topic[];
  programmes: Programme[];
  allTopics: Topic[];
  errorMessage: any;
  topicTypeID = Topic.typeIDTopic;
  currentTopic: Topic;

  constructor(
    private voxPopService: VoxPopService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  loading = false;
  get listTitle(): string { return this.topicTypeID === Topic.typeIDWire ? 'Wires' : 'Topics'; }
  get singular(): string { return this.topicTypeID === Topic.typeIDWire ? 'Wire' : 'Topic'; }

  ngOnInit(): void {
    if (!ProfileService.IsLoggedIn()) { return; }
    this.voxPopService.myActiveProgrammes().subscribe(programmes => this.programmes = programmes);
    this.route.url.subscribe((segments: UrlSegment[]) => {
      this.topicTypeID = segments.some(segment => segment.path === 'wires') ? Topic.typeIDWire : Topic.typeIDTopic;
      document.getElementById('title').innerText = this.listTitle;
      this.loadTopics();
    });
  }

  loadTopics(): void {
    this.loading = true;
    this.errorMessage = '';
    const request = this.topicTypeID === Topic.typeIDWire ? this.voxPopService.activeWires() : this.voxPopService.activeTopics();
    request.subscribe(
      topics => { this.topics = topics || []; this.loading = false; },
      () => { this.errorMessage = 'Could not load ' + this.listTitle.toLowerCase() + '. Please retry.'; this.loading = false; },
    );
  }

  gotoDetail(topic: Topic): void {
    this.router.navigate(['/review/responses/topic/', topic.id]);
  }

  addTopic(): void {
    this.adding = true;
  }

  closeDetail(): void {
    this.adding = false;
    this.loadTopics();
  }

  getColorFor(topic: Topic): string {
    if (this.errorMessage) { return '#ff8080'; } // So editor doesn't make me think this can be static
    if (topic.active) { return '#f4f8f8'; }
    return '#EEEEEE';
  }

}

